import { DugoutLogoSvg } from '@thrivetribe/mvf.assets.logo';
import { HeaderContainer, HeaderProfileNav } from '@thrivetribe/mvf.ui.organisms.header';
import React from 'react';

type Link = {
    url: string;
    text: string;
}

export type OnboardingPageHeaderProps = {
    links?: Link[]
    user?: string;
    hideProfile?: boolean;
};

export const HeaderLogo: React.FC = () => {
    return (
        <div className="header__logo">
            <DugoutLogoSvg />
        </div>
    );
};

export function OnboardingPageHeader(props: OnboardingPageHeaderProps) {
    const { links, user, hideProfile } = props;
    return (
        <div className='onboarding-page__heading'>
            <HeaderContainer>
                <HeaderLogo />
                {!hideProfile && <HeaderProfileNav links={links} user={user} />}
            </HeaderContainer>
        </div>
    );
}
